import { Link } from "react-router-dom";
import React from "react";

function PricingPlan() {
  return (
    <div>
      <div className="pricing-plan-wrapper">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-9 col-md-8 col-xl-7">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Pricing Plan
                </div>
                <h2 className="text-white">Our Pricing Plans</h2>
              </div>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div
                className="price-card2 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="300ms"
              >
                <div className="plan-name">classNameic</div>
                <p>
                  Aliquam eu nunc imperdiet, volut, lobortis ligula. pharetra
                  dignissim lacus, faucibus.
                </p>
                <h2 className="price-value">
                  $2,450<span>/Month</span>
                </h2>

                <ul className="ps-0 list-unstyled">
                  <li>
                    <i className="ti ti-check"></i>Lawyer phone access
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Upfront cost & expectancy
                  </li>
                  <li>
                    <i className="ti ti-check"></i>No overcharges
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Payment plans available
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Free one year support
                  </li>
                </ul>

                <Link to="#" className="btn btn-primary w-100">
                  <span>Select This Plan</span>
                  <span>Select This Plan</span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div
                className="price-card2 active wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="500ms"
              >
                <div className="plan-name">Premium</div>
                <p>
                  Aliquam eu nunc imperdiet, volut, lobortis ligula. pharetra
                  dignissim lacus, faucibus.
                </p>
                <h2 className="price-value">
                  $5,550<span>/Month</span>
                </h2>

                <ul className="ps-0 list-unstyled">
                  <li>
                    <i className="ti ti-check"></i>Lawyer phone access
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Upfront cost & expectancy
                  </li>
                  <li>
                    <i className="ti ti-check"></i>No overcharges
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Payment plans available
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Free one year support
                  </li>
                </ul>

                <Link to="#" className="btn btn-primary w-100">
                  <span>Select This Plan</span>
                  <span>Select This Plan</span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div
                className="price-card2 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="700ms"
              >
                <div className="plan-name">Enterprise</div>
                <p>
                  Aliquam eu nunc imperdiet, volut, lobortis ligula. pharetra
                  dignissim lacus, faucibus.
                </p>
                <h2 className="price-value">
                  $10,940<span>/Month</span>
                </h2>

                <ul className="ps-0 list-unstyled">
                  <li>
                    <i className="ti ti-check"></i>Lawyer phone access
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Upfront cost & expectancy
                  </li>
                  <li>
                    <i className="ti ti-check"></i>No overcharges
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Payment plans available
                  </li>
                  <li>
                    <i className="ti ti-check"></i>Free one year support
                  </li>
                </ul>

                <Link to="#" className="btn btn-primary w-100">
                  <span>Select This Plan</span>
                  <span>Select This Plan</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default PricingPlan;
